import { useMutation } from '@tanstack/react-query';

import { organizationServices } from '@hero/services';

export const useSendAuthEmail = options => {
  return useMutation(body => organizationServices.sendAuthEmail(body), {
    ...options
  });
};
